import React from "react"
import Navigation from "./Navigation"
import { Routes, Route, useLocation } from 'react-router-dom';

import Restricted from "./Restricted"
import DarkModeToggle from "./DarkModeToggle"

import Login from "../User/Login"
import Register from "../User/Register"
import Profile from "../User/Profile"

const App = (params) => {
	const location = useLocation();
	// The header bar's branding + account dropdown don't apply before the
	// user is signed in, so it's hidden on the login/register pages.
	const hideNavigation = location.pathname === "/login" || location.pathname === "/register";
	return (
		<div>
			<DarkModeToggle />
			{!hideNavigation && <Navigation />}
			<Routes>
				<Route exact path="/" element={<Restricted><Profile /></Restricted>} />
				<Route path="/login" element={<Login />} />
				<Route path="/register" element={<Register />} />
				<Route path="/profile" element={<Restricted><Profile /></Restricted>} />
				<Route render={() => (<div>Miss</div>)} />
			</Routes>
		</div>
	)
};

export default App
